import { Link } from "react-router-dom";

const LOGO = "/brand/mbp_logo.png";

export function BrandLogo({ to, compact = false, dark = false, className = "" }) {
  const body = (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <img src={LOGO} alt="MyBigPlate" className={compact ? "h-9 w-auto" : "h-12 w-auto"} />
      {!compact && (
        <span className="flex flex-col leading-none">
          <span className={`font-display text-lg font-extrabold ${dark ? "text-white" : "text-slate-950"}`}>MyBigPlate</span>
          <span className="mt-1 text-[7.5px] font-semibold uppercase tracking-[0.2em] text-slate-400">product of arismeta</span>
        </span>
      )}
    </span>
  );
  if (to) return <Link to={to} aria-label="MyBigPlate">{body}</Link>;
  return body;
}
